export default __webpack_public_path__ + "static/bg_hero-cb5861be50f1871624ffa03d5dfc6cc5.svg";